import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.promise.js";
import _isFunction from "lodash/isFunction";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.is-array.js";
import "regenerator-runtime/runtime.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Form, Row, Col, FileInput, Button } from 'components/UI';
import { showApiError } from 'utils';
import { getDocumentImages, addDocumentImages } from 'services';
import { jsx as ___EmotionJSX } from "@emotion/react";

var BorrowerIdCardForm = function BorrowerIdCardForm(_ref) {
  var borrowerIdNumber = _ref.borrowerIdNumber,
      documents = _ref.documents,
      onNext = _ref.onNext,
      onDocumentsSave = _ref.onDocumentsSave;

  var _useState = useState(documents),
      _useState2 = _slicedToArray(_useState, 2),
      documentsData = _useState2[0],
      setDocumentsData = _useState2[1];

  useEffect(function () {
    !documents && fetchDocuments();
  }, []);

  var fetchDocuments = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _yield$getDocumentIma, _yield$getDocumentIma2, res, err;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getDocumentImages(borrowerIdNumber);

            case 2:
              _yield$getDocumentIma = _context.sent;
              _yield$getDocumentIma2 = _slicedToArray(_yield$getDocumentIma, 2);
              res = _yield$getDocumentIma2[0];
              err = _yield$getDocumentIma2[1];

              if (!err) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return", showApiError(err));

            case 8:
              setDocumentsData(res === null || res === void 0 ? void 0 : res.current);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchDocuments() {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleSubmit = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref3) {
      var values, isEdited, _yield$addDocumentIma, _yield$addDocumentIma2, res, err;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              values = _ref3.values, isEdited = _ref3.isEdited;

              if (!isEdited) {
                _context2.next = 13;
                break;
              }

              _context2.next = 4;
              return addDocumentImages(borrowerIdNumber, values);

            case 4:
              _yield$addDocumentIma = _context2.sent;
              _yield$addDocumentIma2 = _slicedToArray(_yield$addDocumentIma, 2);
              res = _yield$addDocumentIma2[0];
              err = _yield$addDocumentIma2[1];

              if (!err) {
                _context2.next = 10;
                break;
              }

              return _context2.abrupt("return", showApiError(err));

            case 10:
              _isFunction(onDocumentsSave) ? onDocumentsSave(res) : setDocumentsData(res);
              _context2.next = 14;
              break;

            case 13:
              _isFunction(onDocumentsSave) && onDocumentsSave();

            case 14:
              _isFunction(onNext) && onNext();

            case 15:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleSubmit(_x) {
      return _ref4.apply(this, arguments);
    };
  }();

  return ___EmotionJSX(Form, {
    onSubmit: handleSubmit,
    values: documentsData
  }, ___EmotionJSX(Row, {
    sm: 12,
    md: 6,
    horizontalGap: 16,
    verticalGap: 16
  }, ___EmotionJSX(Col, null, ___EmotionJSX(FileInput, {
    accept: "image/*",
    formId: "front",
    label: "\u041B\u0438\u0446\u0435",
    id: "front",
    required: true,
    max: 30,
    infoText: "\u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u0435\u043D \u0440\u0430\u0437\u043C\u0435\u0440: 30 MB!"
  })), ___EmotionJSX(Col, null, ___EmotionJSX(FileInput, {
    accept: "image/*",
    formId: "back",
    label: "\u0413\u0440\u044A\u0431",
    id: "back",
    required: true,
    max: 30,
    infoText: "\u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u0435\u043D \u0440\u0430\u0437\u043C\u0435\u0440: 30 MB!"
  })), ___EmotionJSX(Col, {
    displayFlex: true,
    md: 12,
    justify: "flex-end"
  }, function (_ref5) {
    var onSubmit = _ref5.onSubmit;
    return ___EmotionJSX(Button, {
      onClick: onSubmit
    }, "\u0417\u0430\u043F\u0430\u0437\u0438");
  })));
};

BorrowerIdCardForm.propTypes = {
  onNext: PropTypes.func,
  onDocumentsSave: PropTypes.func,
  borrowerIdNumber: PropTypes.string,
  documents: PropTypes.object
};
export default BorrowerIdCardForm;